module.exports = __webpack_public_path__ + "static/hvhh-4-d70da4064b92d045702d3bda56e36581.png";